import * as basicScroll from 'basicscroll';
const imagesLoaded = require('imagesloaded');

const heroSection = document.querySelector('.block-hero-display');
const heroImageWrapper = document.querySelector(
	'.block-hero-display__image-wrapper'
);

const parallax = () => {
	if (heroSection) {
		const instance = basicScroll.create({
			elem: heroSection,
			direct: heroSection,
			from: 'top-top',
			to: 'bottom-top',
			props: {
				'--sectionScroll': {
					from: '0',
					to: '1',
				},
			},
		});

		instance.start();
	}
};

const images = () => {
	if (heroImageWrapper) {
		imagesLoaded(
			heroImageWrapper,
			{ background: true },
			function (instance) {
				if (instance.elements.length && instance.elements[0]) {
					instance.elements[0].classList.add('loaded');
				}
			}
		);
	}
};

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		parallax();
		images();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp() {},
};
export default controller;
